import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Paper,
  Box,
  Button,
  Backdrop,
  CircularProgress,
  Divider,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TableHead,
  useTheme,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useDispatch, useSelector } from "react-redux";
import history from "../../utils/HistoryUtils";
import AlertDialog from "../../components/Alert/AlertDialog";
import Notification from "../../components/Notification/Notification";
import { deleteTrust } from "../../store/action";
import { getSingleTrustById } from "../../store/action/trust/trustAction";
import EnhancedTableHead from "../Signee/EnhancedTableHead";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import EditContactEventDialog from "../Signee/EditContactDialog";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  getContactEventForSignee,
} from "../../../src/store/action/signee/signeeAction";
import { headCellsContactEvent } from "../Signee/HeadcellsContactEvent";
import moment from "moment";
import CreateContactEvent from "./CreateContactEvent";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "hidden",
    padding: theme.spacing(3),
    background: "#f9fafc",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  label: {
    fontWeight: 500,
    color: "#666",
    fontSize: "0.9rem",
  },
  value: {
    fontWeight: 600,
    color: "#222",
    fontSize: "1rem",
  },
  card: {
    borderRadius: 16,
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    marginBottom: theme.spacing(3),
    background: theme.palette.background.main,
    marginTop: theme.spacing(3),
  },
  footerBar: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    zIndex: 1000,
    background: theme.palette.thead,
    boxShadow: "0 -4px 10px rgba(0,0,0,0.08)",
  },
  button: {
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 600,
    padding: "6px 20px",
  },
  cellId: {
    color: theme.palette.text.secondary,
  }
}));

const DetailTrust = ({ match }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const id = match.params.id;

  const [Id, setId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [trustItems, setTrustItems] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);

  const { deleteTrustSuccess, deleteTrustError } = useSelector(
    (state) => state.trust
  );
  const [searchData, setSearchData] = useState({ search: "" });
  const [page, setPage] = React.useState(1);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("created_at");
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const loginUserInfo = JSON.parse(window.localStorage.getItem("loginUserInfo"));
  const user_id = match.params.id;
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const loginDetail = JSON.parse(localStorage.getItem("loginUserInfo"));
  const getSingleTrust = async () => {
    setLoading(true);
    dispatch(
      getSingleTrustById(id, (result) => {
        if (result?.data) {
          setTrustItems(result?.data);
        }
        setLoading(false);
      })
    );
  };
  const handleClose = () => {
    setOpen(false);
  }
  const getevent = (pageNo = 1, search = "") => {
    dispatch(getContactEventForSignee(pageNo, search, user_id, orderBy, order));
  };
  const {
    getCandidateEventItem,
  } = useSelector((state) => state.signee);

  const [visibleColumnsContactEvent, setVisibleColumnsContactEvent] = useState(
    headCellsContactEvent[0].map((col) => col.id) // initially all columns visible
  );

  const openEditDialog = (row) => {
    setEditDialog(true);
    // console.log(row)
    setContactData(row);
  };
  const [editDialog, setEditDialog] = useState(false);
  const [contactData, setContactData] = useState({});
  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(getevent(page, d1), 100);
    } else {
      setTimeout(getevent(page, ""), 100);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };
  useEffect(() => {
    getevent(1, "");
  }, [orderBy, order]);

  useEffect(() => {
    getevent(1, "");
  }, [user_id]);
  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleClickSearch = (event, value) => {
    setTimeout(getevent(page, searchData.search), 1000);
  };
  useEffect(() => {
    if (id) getSingleTrust();
  }, [id]);

  const upadateLink = () => history.push(`update`);
  const deleteTrustClose = () => setDeleteOpen(false);
  const alertResponse = (id) => {
    dispatch(deleteTrust(id));
    setStaffNotify(true);
  };
  const deleteStaffItem = (id) => {
    setDeleteOpen(true);
    setId(id);
  };

  const customerDetails = [
    { label: "Customers Name", value: trustItems?.name || "N/A" },
    { label: "Customer Code", value: trustItems?.code || "N/A" },
    { label: "Framework", value: trustItems?.framework || "N/A" },
    { label: "VAT", value: trustItems?.vat || "N/A" },
    { label: "LLP Status", value: trustItems?.llp_status || "N/A" },
    { label: "AWR", value: trustItems?.awr || "N/A" },
    { label: "LPP Trust Code", value: trustItems?.llp_trust_code || "N/A" },
    { label: "Cost Center Code", value: trustItems?.cost_center_code || "N/A" },
    { label: "Cash Connect No", value: trustItems?.cash_connect_no || "N/A" },
    { label: "Contract", value: trustItems?.contract || "N/A" },
  ];
  const redirectOnContact = () => history.push(`contactEvents`);
  const theme = useTheme();
  return (
    <>
      {loading && (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {staffNotify && deleteTrustSuccess?.message && (
        <Notification data={deleteTrustSuccess?.message} status="success" />
      )}
      {staffNotify && deleteTrustError?.message && (
        <Notification data={deleteTrustError?.message} status="error" />
      )}

      {/* <div className={classes.root}> */}
      {/* Customer Details */}
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6"
          >Customer Details</Typography>
          <Grid container spacing={2}>
            {customerDetails.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Typography style={{ color: theme.palette.listItem }}>{item.label}</Typography>
                <Typography fontWeight="bold">{item.value}</Typography>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6"
          >Site</Typography>
          <Box elevation={2} sx={{ marginBottom: "30px" }}>
            {trustItems?.hospital?.map((items, index) => (
              <Accordion key={index} sx={{ mb: 2, boxShadow: 2, borderRadius: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ background: theme.palette.thead }}>
                  <Grid container spacing={2} style={{ background: theme.palette.thead }}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Site Name</Typography>
                      <Typography>{items.hospital_name || "—"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Client Type</Typography>
                      <Typography>{items.client_type || "—"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Charge Area</Typography>
                      <Typography>{items.charge_area || "—"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography fontWeight="bold">Client Address</Typography>
                      <Typography>{items.client_address || "—"}</Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <Typography variant="body2" style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px", background: "#e2e2e7" }}>Ward</Typography>
                <AccordionDetails style={{ background: theme.palette.background.main }}>
                  {items?.ward?.length ? (
                    <>
                      <Table style={{ background: theme.palette.background.main }}>
                        <TableHead >
                          <TableRow style={{ backgroundColor: theme.palette.thead }}>
                            <TableCell style={{ color: theme.palette.listItem }}>S/No</TableCell>
                            <TableCell style={{ color: theme.palette.listItem }}>Ward Name</TableCell>
                            <TableCell style={{ color: theme.palette.listItem }}>Type</TableCell>
                            <TableCell style={{ color: theme.palette.listItem }}>Phone Number</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {items.ward.map((ward, wIndex) => (
                            <TableRow key={wIndex}>
                              <TableCell style={{ color: theme.palette.listItem }}>{wIndex + 1}</TableCell>
                              <TableCell style={{ color: theme.palette.listItem }}>{ward.ward_name || "—"}</TableCell>
                              <TableCell style={{ color: theme.palette.listItem }}>{ward.ward_type || "—"}</TableCell>
                              <TableCell style={{ color: theme.palette.listItem }}>{ward.phone_number || "—"}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </>
                  ) : (
                    <Box textAlign="center" py={2}>
                      <Typography color="textSecondary">No Wards Available</Typography>
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </CardContent>
      </Card >
      {/* Contact Information */}
      {
        trustItems?.contact?.length > 0 && (
          <Card className={classes.card}>
            <CardContent>
              <Typography variant="h6">
                Contact Information
              </Typography>
              {trustItems.contact.map((contact, contactIndex) => (
                <Box key={contactIndex} mb={2}>
                  <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8 }}>
                    Contact {contactIndex + 1}
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      { label: "First Name", value: contact.first_name },
                      { label: "Last Name", value: contact.last_name },
                      { label: "Email Address", value: contact.contact_email_address },
                      { label: "Phone Number", value: contact.phone_number },
                      { label: "Client", value: contact.client },
                      { label: "Department", value: contact.department },
                    ].map((field, fieldIndex) => (
                      <Grid item xs={12} sm={6} md={4} key={fieldIndex}>
                        <Typography style={{ color: theme.palette.listItem }}>{field.label}</Typography>
                        <Typography fontWeight="bold">{field.value || "—"}</Typography>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              ))}
            </CardContent>
          </Card>
        )
      }
      {/* </div > */}

      {/* Footer Action Bar */}
      < div className={classes.footerBar} >
        <Button
          variant="contained"
          color="default"
          onClick={() => history.goBack(-1)}
          className={classes.button}
        >
          Cancel
        </Button>
        <div>
          <Button
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={redirectOnContact}
            className={classes.button}
            style={{ marginRight: 12 }}
          >
            Contact Event List
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.goBack(-1)}
            className={classes.button}
            style={{ marginRight: 12 }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={upadateLink}
            className={classes.button}
            style={{ marginRight: 12 }}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<DeleteIcon />}
            onClick={() => deleteStaffItem(trustItems.id)}
            className={classes.button}
          >
            Delete
          </Button>
        </div>
      </div >
      <CreateContactEvent open={open} handleClose={handleClose} signee_id={user_id} />

      <EditContactEventDialog
        title="edit"
        open={editDialog}
        data={contactData}
        setData={setContactData}
        handleClose={() => setEditDialog(false)}
      />
      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deleteTrustClose}
        response={alertResponse}
        title="Delete Customers"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />
    </>
  );
};

export default DetailTrust;
